const currentYear = new Date().getFullYear();
// comment adClientId in test environment
const adClientId = "ca-pub-2924409830318564";
// const adClientId = "ca-pub-xxxxxxxxxxxxxxxxxx";

export const CommonTexts = {
    defaultCompanyLogo: "https://s3-ap-southeast-1.amazonaws.com/xpressjobstest/Organizations/xpressjobs_logo.jpg",
    defaultUser: process.env.PUBLIC_URL + "/img/default_user.jpg",
    metaDescription: "Sri Lanka's best job portal connecting talent with trusted opportunities. XpressJobs powers recruitment for over 10,000 organizations with local expertise",
    siteTitle: "XPRESSJOBS : Jobs in Sri Lanka",    
    verifyEmail: "Please check your email to find the confirmation email and click on the verification link to verify your account."
}

export const Contacts = {
    address: {
        no: "2-2/1,",
        road: "Temple Lane,",
        city: "Colombo 03."
    },
    email: "info@xpress.jobs",
    telephone: "+94117422414"
}

export const HomeTexts = {
    heading: "Give your Career a Jumpstart",    
    desktopText: "XpressJobs is Sri Lanka’s premier Job Board. A marketplace tasked to help companies hire the best talent. XpressJobs is already trusted by over 10000 Sri Lankan and global organizations, and has a proven track record of utilizing recruitment technology with a Sri Lankan touch. XpressJobs has now processed over 6 million job applications.",
    mobileText: "XpressJobs is Sri Lanka’s premier Job Board. XpressJobs is already trusted by over 10000 Sri Lankan and global organizations, and processed over 6 million job applications.",
    mobileSearch: "I'm looking for...",
    desktopSearch: "I'm looking for...   (Eg : Job title, Position, Company)",
    metaDescription: "Sri Lanka's best job portal connecting talent with trusted opportunities. XpressJobs powers recruitment for over 10,000 organizations with local expertise",
    siteTitle: "XPRESSJOBS : Jobs in Sri Lanka"    
}

export const CandidateHomeTexts = {
    recommendedJobs: "Recommended For You",
    appliedJobs: "Jobs You Applied",
    viewAllUpper: "VIEW ALL",
    viewAllLower: "View All",
    loadMoreUpper: "LOAD MORE",
    loadMoreLower: "Load More",
    sortBy: "Sort by",
    savedJobPosts: "Saved Job Posts",
    savedJobs: "Saved Jobs",
    jobPosts: " Job Posts",
    adClient: adClientId,
    verticalAdSlot: "2458974270",
    noAppliedJobs: "You haven't applied for any jobs yet.",
    verifyEmail: "Please check your email for the confirmation link to verify your account."
}

export const JobCategoriesTexts = {
    title: "Job Categories"
}

export const FeaturedJobsTexts = {
    title: "Featured Jobs"
}

export const TopHiringOrganizationsTexts = {
    title: "Top Hiring Companies"
}

export const FooterTexts = {
    address: "2-2/1, Temple Lane, Colombo 03, Sri Lanka",
    email: "info@xpress.jobs",
    telephone: "011-7422414",    
    newsletterText: "Subscribe to our newsletter and receive an email alert on the most matching jobs every Wednesday.",
    searchPlaceholder: "Enter your email. . .",
    emailError: "Invalid email address",
    copyright: `© ${currentYear} XpressJobs.lk (Pvt) Ltd. All Rights Reserved`
}

export const JobViewTexts = {
    video: "Video",
    urgent: "Urgent",
    apply: "APPLY FOR JOB",
    downloadApplication: "DOWNLOAD JOB APPLICATION",
    save: "SAVE JOB",
    summary: "Summary",
    education: "Education",
    experience: "Experience",
    salary: "Salary Range",
    Benefits: "Benefits",
    description: "Job Description",
    jobAd: "View Job Ad",
    unemployment: "Unemployment in Sri Lanka is estimated to be over 390,816, Share this job and help another!",
    jobPost: " Job Post",
    jobPosts: " Job Posts",
    adClient: adClientId,
    verticalAdSlot: "4820030849",
    horizontalAdSlotOne: "5941540827",
    horizontalAdSlotTwo: "7063050802",
    alert: "This job is no longer accepting applications. Please explore other opportunities."
}

export const SearchPageTexts = {
    results: " Job Results",
    sortBy: "Sort by",
    perPage: "Posts Per Page",
    searchFilters: "Search Filters",
    industry: "All Industries",
    jobType: "Job Type",
    jobLevel: "Job Level",
    posted: "Posted",
    location: "Location",
    remote: "Work From Home / Hybrid",
    saveSearch: "Save This Search",
    savePlaceholder: "Give it a name…",
    saveButton: "SAVE SEARCH",
    saveSearchSuccess: "Search saved successfully",
    saveSearchError: "Error occurred while saving",
    searchHistoryNoCandidate: "You need to login to your account to get saved search histories",
    searchHistoryNoResult: "You have no saved search histories",
    adClient: adClientId,
    verticalAdSlotOne: "8789289349",
    verticalAdSlotTwo: "1956239255",
    verticalAdSlotThree: "1281451837",
    horizontalAdSlotOne: "4925054191",
    horizontalAdSlotTwo: "7359645844"
}

export const JobApplyPageTexts = {
    applyStage: {
        apply: "Apply for this job",
        screening: "Screening Stage",
        applied: "Successfully applied for the job",
        drafted: "Application Successfully Drafted"
    },
    stageDescription: {
        apply: "Please fill in your details below, then click 'Apply' button to submit your application. Your application will be treated with absolute confidentiality.",
        cvLessApply: "Please fill out the details below to submit your application. Your application will be treated with absolute confidence. Please note that the job is a CV-less job; however, we recommend you submit your CV at the next stage if you possess one. Answering all questions increases your chances of landing an interview.",
        screening: "Please answer the below questions accurately to increase your chances of being selected (shortlisted) for an interview. Applicants providing false answers may be disqualified from applying through XpressJobs.",
        applied: "Well done! Your application will now reach the recruiter. Please go to \"Status of Applications\" to view the status and progress of your application. Wishing you all the best.",
        drafted: "Congratulations! Your job application has been securely drafted. Continue your application journey from where you left off by visiting the 'Draft' page. Best of luck in your job search!"
    },
    fullName: "Full Name *",
    email: "Email *",
    cv: "CV *",
    cvDescription: "Please note, current CV displayed on the left will be sent to the recruiter when you hit the apply button. Once the application is sent out, the CV cannot be changed or updated. Please send out the latest CV available.",
    coverLetter: "Cover Letter (Optional)",
    uploadCV: "Drop file here or click to select",
    uploadCVMobile: "Click to select",
    maxFileSize: "Max file size : 2MB",
    applyNotice: "Please make sure to complete the 'questionnaire' at the next stage of application. We recommend the jobseekers to have two working phone numbers on the CV.",
    applyButton: "APPLY FOR JOB",
    submitNotice: "When you click the submit button, the CV and the answers provided will be sent immediately and directly to the recruiter. The content submitted will be considered final. Only shortlisted candidates will be contacted.",
    submitButton: "SUBMIT",    
    cvLessApplyNotice: "Please note that once you hit the submit button, the application will be directly sent to the recruiter.",
    cvLessCVUpload: "Your application has been sent to the organisation successfully. If you would like to upload your CV, please proceed.",
    saveDraft: "Save Draft",
    cancelButton: "Cancel",
    backToSearch: "BACK TO SEARCH",
    readTheGuidlines: "read the guidelines before answer the questions.",
    guideLinesTitle: "Application Screening Criteria",
    guideLines: [
        "Answers you provide are used to screen your application. This is an automated process.",
        "A score is calculated based on the answers you provide. If your score is less than the pass mark, the application will be marked as \"screening failed\". However, the application will get forward to the applied company via an email.",
        "Even though you have passed the screening, employers have the right to call only the selected candidates.",
        "Fake answers would get the recruiters to flag you. (E.g. If you do not have a degree, please don't click Yes.) 5 fake answer triggers from recruiters would result your account to be blacklisted.",
        "If you commit to attend to an interview and do not show-up, your account would be marked as \"interview no show\". 5 interview no show triggers from recruiters would result your account to be blacklisted."
    ],
    questionnaireNotCompleted: "Looks like you haven't answered some questions. Please answer to proceed.",
    viewMyApplications: "VIEW MY APPLICATIONS",
    viewDrafts: "VIEW DRAFTS",
    backToHome: "GO BACK TO HOME"
}

export const GetInTouchTexts = {
    title: "Got A Question? Get In Touch",
    description: "We're here to help. Send us an email or Call us at ",
    telephone: "+94117422414",
}

export const SubmitFormText = {
    error : "Some of the required fields are missing."
}

export const CandidateProfilePageTexts = {
    shareCV: "Share my CV with employers",
    completeProfile: "Complete your profile for better experience",    
    deleteWarningMessage: "This will delete your profile with all the saved information. And those includes …",
    deleteSuccessMessage: "Your Xpressjobs account is deleted successfully. Thank you for using Xpressjobs",
    adClient: adClientId,
    verticalAdSlot: "3875997725",
    horizontalAdSlot: "4684299472",
    addNewCV: "Add new CV to your profile",
    fileSize: "Max file size : 2MB"
}

export const CVFormatsPageTexts = {
    text: "Don’t pay for expensive CV-writers or waste your time looking for CV formats that are editable. You can now choose a CV-format depending on the job type you would like to apply and buy it off Xpressjobs for just Rs 300/= per CV."
}

export const DisabilityFriendlyTexts = {
    heading: "Employment Opportunities for the Ready, Willing and Able to Work !",
    disabledLadyImageURL: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/disability-friendly/disabled-lady-working.png",
    guyWithIPadImageURL: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/disability-friendly/disabled-guy-with-ipad.png",
    posts: [
        {
            title: "Differently-Abled Friendly Employment",
            paragraphs: [
                "We get many calls, emails from individuals who are differently-abled struggling to find work in Sri Lanka. The single biggest barrier to full employment for the differently-abled is the “fear of the unknown” not knowing if a company is open to hiring them. At the same time we had companies who loved to hire ready willing and able to work individuals and just wanted to get this news out there!",
                "So we bridge the gap by introducing a new tick off box for companies to indicate they offer disabled friendly employment in the job site.",
                "We currently have many companies onboard and signed up with us who are offering differently-able friendly employment and the list keeps growing daily. The logo in front of the company will indicate that they are differently-abled friendly.",
                "We hope the site will also help identify job opportunity for people with different disabilities - Visual, auditory, orthopedic, etc. in a much easier manner."
            ]
        },
        {
            title: "Placement For The Differently-Abled",
            paragraphs: [
                "The objective of this page is to find gainful employment to those who are physically challenged in some way. The job seekers can easily access this site and post their profile and explain what kind of job they are looking for and will have the ability to mention details about them.",
                "The site can also be used by the employers who would like to engage the differently challenged people in their organization. They can post the jobs available in the organization for which they are willing to employ differently-abled people also want to give them and equal opportunity to apply.",
                "The employers can also search and access the job profiles of the job seekers and directly contact them and assess the suitability of the candidates."
            ]
        }
    ],
    offerJobTitle: "Are You A Recruiter And Willing To Offer A Job?",
    offerJobContent: "Would like to be listed as an equal opportunity provider/ differently-abled friendly employment ?",
    offerJobSubContent: "Sign up with us if you’re not already registered. If you already recruit through us, just email us at info@xpress.jobs or give us a call to get your company listed on this page too.",
    bottomText: "Share this link to differently-abled individuals, spread the word so more companies will come on board with us to give an equal opportunity to differently-abled candidates."
}

export const CandidatePremiumPageTexts = {
    makePremium: "Make Your Account Premium!",
    description: "Making your account premium will make your CV go to the top of the CV list of every application you make. When a recruiter logs into the recruiter accounts your CV would be one of the prioritized CVs and on top of the CV pile giving you a higher chance of being shortlisted for an interview.",
    makeTop: "Make your application on top of the application list",
    highlightApplication: "Highlight your application to recruiters with a “premium label”",
    adsFree: "Google Ads free job browsing",
    bioData: "Give a quick glance of your xpressjobs account bio-data to recruiters when they click on your name"
}

export const PreferredPartnersTexts = {
    text: "Please click on each logo to understand more details on each respective partnership. If you think of possible partnerships with XpressJobs please get in touch with us."
}

export const ErrorPageTexts = {
    connect: "We couldn’t connect the wires",
    unavailable: "The page you are looking for might have been removed or is temporarily unavailable.",
    copyright: "© 2025 XpressJobs.lk (Pvt) Ltd. All Rights Reserved"
}

export const OrganizationPageTexts = {    
    adClient: adClientId,    
    horizontalAdSlotOne: "1178462447",
    horizontalAdSlotTwo: "6047645744"
}

export const PaymentIcons: string[] = [    
    process.env.PUBLIC_URL + "/img/visa.png",
    process.env.PUBLIC_URL + "/img/vishwa.png",
    process.env.PUBLIC_URL + "/img/ez-cash.png",
    process.env.PUBLIC_URL + "/img/m-cash.png",
    process.env.PUBLIC_URL + "/img/amex.png",
    process.env.PUBLIC_URL + "/img/vw.png"
]

export const ForRecruitersTexts = {
    metaTitle: "Struggling to find the right candidate? Try us out!",
    metaDescription: "",
    header: {
        title: {
            white: "Struggling to find the right candidate?",
            blue: " Try us out!"
        },
        descriptionMobile: "XpressJobs is currently working with over 12000 national and international clients and caters to recruiting both white-collar and blue-collar cadres. XpressJobs has been the market trendsetter in recruitment tech by introducing filtering, CV-Less jobs, online quizzes, video jobs, etc. We have now processed over 6M applications to date. Please get in touch for more info.",
        descriptionDesktop: "XpressJobs is currently working with over 12000 national and international clients and caters to recruiting both white-collar and blue-collar cadres. XpressJobs has been the market trendsetter in recruitment tech by introducing filtering, CV-Less jobs, online quizzes, video jobs, etc. We have now processed over 6M applications to date. Please get in touch for more info."        
    },
    services: {
        title: "Our best services",
        leadingApplication: {
            green: "Leading Application",
            black: " tracking system in the country",
            description: "Candidates will be filtered out by asking customized questions according to the job description or requirements provided by you.",
            image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/filter-out.png"            
        },
        filterOut: {
            image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/new-screening-page.png",
            black: "Filter out the",
            blue: " best candidates",
            description: "Not everyone who applies will match what you’re looking for, and that’s exactly why this feature exists. Originally built for HSBC Sri Lanka, when you post a job, we create a <strong>custom questionnaire (yes/no, single-choice, multiple-choice, or knockout questions)</strong>. Candidates submit their answers along with their CV, giving you instant clarity on whether they actually fit the job specs, especially since many applicants don’t read the advert properly.<br><br>This simple filter cuts HR workload by <strong>up to 70%</strong>, helping you spot the people worth interviewing in seconds and get to the strongest talent faster."
        },
        trackCandidates: {
            image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/ats-full-view.png",
            black: "Track your candidates",
            blue: " all in one place",
            description: "The Application Tracking System (ATS) gives recruiters everything they need to hire faster, all in one clean dashboard. <br>You can <strong>move candidates to shortlist</strong>, <strong>filter applicants smarter</strong>, <strong>take interview notes</strong>, <strong>record statuses</strong>, and even <strong>check CV open rates </strong> to see who’s being reviewed. <br><br>Recruiters can take interview notes, download CVs in bulk, invite candidates for interviews directly through the system, and keep every update organised without switching between emails or spreadsheets. It’s simple, fast, and built to help HR teams work smarter and make better hiring decisions."
        },
        muchNeeded: {
            image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/statistic.png",
            black: "Much needed",
            blue: " Statistics and Trends",
            description: "XpressJobs’ Statistics & Trends dashboard gives HR leaders <strong> visibility </strong> no other job portal in Sri Lanka offers. It shows how many CVs are <strong>opened, shortlisted</strong>, which job descriptions perform best, how many candidates commit to interviews, and where drop-offs happen. <br><br>All our clients use this data to improve job ads, understand candidate behaviour, boost HR team efficiency, and make faster, evidence-based decisions. It also helps Heads of HR clearly track team performance and identify where hiring can be optimised."
        },
        onlineQuizzes: {
            image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/quizzess.png",
            black: "Online",
            blue: " Quizzes",
            description: "XpressJobs Online Quizzes give recruiters a smart <strong>second layer of filtering </strong> beyond basic CV screening. After applicants pass our initial filters and enter the ATS, they can be instantly assessed through <strong>timed online tests</strong> in math, English, aptitude, or any custom MCQ format. <br><br>It’s fast, reliable, and already trusted by major programs like the <strong> Nestlé Management Trainee intake </strong> and <strong> Hemas Internship Program.</strong><br><br> A simple way to identify the strongest candidates, with zero manual hassle."
        },
        aiAssistent: {
            image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/ai-assistant.jpg",
            black: "AI Recruitment",
            blue: " Assistant",
            blackStar: " *",
            description: "XpressJobs has introduced <strong>Sri Lanka’s first AI-powered recruitment assistant</strong> on WhatsApp: built to actively reach out and pitch roles, not just share information. The AI pulls data from our jobseeker database to identify candidates who’ve shown interest in similar jobs or match the exact skills recruiters need, then starts a natural WhatsApp conversation to promote the role, answer questions, and drive applications. <br><br> It launched with leading organisations like <strong> John Keells </strong> companies, <strong> BYD Sri Lanka</strong>, and <strong>Keells Distribution</strong>, and has since powered high-volume hiring for <strong>Daraz 11.11, Hemas, Siyapatha Finance, HCL</strong> and more. <br><br> The experience feels like a friendly chat, especially effective for <strong> Gen Z </strong> and <strong>mid-level talent </strong>, who can freely ask anything about the role. It’s a fast, personalised way to reach the right candidates at scale, bringing a modern, human touch to recruitment."
        }
    },
    cvLess: {
        youTubeVideo: "https://www.youtube.com/embed/bBJE1nnQZvY",
        subTitle: "CV-Less jobs",
        title: {
            black: "Opportunity to apply",
            green: " without a CV"
        },
        description: "The CV-less application feature, introduced for <strong>Keells Super (John Keells Company)</strong> to hire cashiers and customer service staff, has since become one of our most effective tools for high-volume hiring. Candidates simply answer a customised set of questions instead of uploading a CV. <br><br> Our system converts their responses into a CV-style profile and sends it directly to the recruiter. This is ideal for <strong> school leavers, skilled labour (NVQ), blue-collar workers, and candidates from suburban areas </strong> who often don’t have formal CVs. <br><br> Today, this feature is widely used, even by <strong> banks and financial institutions </strong> to hire sales teams, recovery staff, and call center staff, ensuring employers don’t miss strong candidates just because they don’t have a CV. It also supports <strong> automated SMS </strong> for walk-in interviews, making the process even faster. A simple, powerful way to reach talent that most employers overlook."
    },
    features: [
        {            
            title: "SMS Service",
            description: "This feature is designed specially for walk-in-interviews. When a job application is sent by the candidates, the candidate will also receive a SMS at the same time to their mobile phone confirming Interview date / Time / Venue / with a contact number of designated person."
        },
        {            
            title: "Online Timed Tests",
            description: "Efficiency in mind, XpressJobs stepped into fine-tune the process with an online test (e.g., English, mathematics, IT, or IQ) that is customised according to the job. With this, applicants need only sit for a timed online test after the initial online screening and visit the company only once for the final interview, thereby reducing the time spent by both recruiter as well as candidate."
        },
        {            
            title: "Targeting from Database",
            description: "XpressJobs has exclusive data from 2025, showing applicants who applied for 'intern' positions in 2015 but are not currently trained professionals. We can also identify who is applying correctly or not. This allows us to determine who is actively seeking jobs, so we can target job vacancies and requirements to the most suitable candidates."
        },
        {            
            title: "Target based social media marketing",
            description: "We can re-target candidates based on factors such as location, age, gender, education, and even work experience across various industries through social media platforms like Facebook and LinkedIn. The graphic design will be handled on our end, and we assist in building your identity as an 'Employer Brand'."
        },
        {            
            title: "Interview Notes",
            description: "Interview notes allow you to take notes during phone interviews and during one-to-one interview sessions itself. The data you enter will remain accessible to you, regardless of whether your account is active or inactive."  
        },
        {            
            title: "Employer Branding",
            description: "We help establish your business as an employer brand. We allow banner spaces, email marketing, and Social media campaigns and also help you place yourself on our sister business: "
        },
        {            
            title: "Target-Based Email Campaign",
            description: "This is not a normal email blast. One of our team members personally reviews the XpressJobs database to find candidates who genuinely match your job requirements from those who applied for similar roles recently to past interns who are now ready for the next step. We then send personalised emails directly to them, giving you much higher open rates and stronger engagement than standard campaigns. It’s focused, timely, and helps you reach the right talent faster (minimum commitment of 1000 emails)."
        },
        {
            title: "Target-Based WhatsApp Campaign",
            description: "This is not a normal bulk blast. We reach shortlisted candidates directly through personalized WhatsApp messages based on your job requirements. Although it’s not a two-way conversation, WhatsApp has a much higher open rate than email especially for Gen Z focused roles. This helps you connect with the right talent quickly and ensures your opportunities are seen where candidates are most active."
        },
        {
            title: "Banner Campaign",
            description: "Our Banner Campaign gives your brand or job openings maximum visibility across XpressJobs’ 6 million monthly sessions, reaching a diverse jobseeker audience aged 18–55. At no extra charge, your banner will be displayed across key touchpoints, including the job search, candidate home, job view, candidate profile, and organization profile pages. It can be used for job ads, employer branding, or product promotions, and can redirect users to any link you choose. With targeted exposure by industry, location, and job category, this is one of the most effective ways to reach the right audience quickly."
        }

    ],
    careers: {
        image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/career-integration.png",
        title: {
            black: "Direct jobs listing to the",
            green: "company careers page"
        },
        description: "All company recruiters hiring through us receive a unique widget that links to your business website, creating a customized job page. This page automatically updates with the jobs you post on XpressJobs, seamlessly integrating with your site."
    },
    packageFeatures: [
        {
            feature: "CV Filtering"           
        },
        {
            feature: "Unlimited Job Posting"           
        },
        {
            feature: "Application Tracking System (ATS)"           
        },
        {
            feature: "CV Less Job Application"           
        },
        {
            feature: "Interview Notes"           
        },
        {
            feature: "Statistics Dashboard"        
        },
        {
            feature: "Direct Jobs Listing to Company Careers Page"            
        },
        {
            feature: "Target Based Social Media Marketing"
        },
        {
            feature: "Video Job Advert"
        },
        {
            feature: "Recruiter Sub Logins"            
        },
        {
            feature: "Recruitment Consultation"
        },       
        {
            feature: "Online Test/Quiz"
        },
        {
            feature: "One Free Featured Advert a Month"
        },
        {
            feature: "Branch Recruitment & CV Routing"
        }, 
        {
            feature: "Complimentary HRNews.lk Article"
        }        
    ],
    featureAvailability: [
        {
            packageId: 2,
            availability: [true, false, true, true, true, true, true, false, false, false, false, false, false, false, false]
        },
        {
            packageId: 3,
            availability: [true, true, true, true, true, true, true, true, false, false, false, false, false, false, false]
        },
        {
            packageId: 4,
            availability: [true, true, true, true, true, true, true, true, true, true, false, false, false, false, false]
        },
        {
            packageId: 5,
            availability: [true, true, true, true, true, true, true, true, true, true, true, false, false, false, false]
        },
        {
            packageId: 6,
            availability: [true, true, true, true, true, true, true, true, true, true, true, true, true, false, false]
        },        
        {
            packageId: 7,
            availability: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
        }
    ],
    packages: {
        subTitle: "Our pricing",
        title: {
            black: "Advertise as many vacancies as you want, ",
            blue: "pay only for the applications"
        },
    },
    crossPublishing: {
        description: "XpressJobs owns and powers <a href='https://internjobs.lk/' target='_blank' rel='noreferrer' style='font-family: Poppins, sans-serif; color: #01A9E0; text-decoration: none;'>InternJobs.lk</a>, <a href='http://myjobs.lk/' target='_blank' rel='noreferrer' style='font-family: Poppins, sans-serif; color: #01A9E0; text-decoration: none;'>MyJobs.lk</a> (acquired), <a href='https://rakiya.lk/' target='_blank' rel='noreferrer' style='font-family: Poppins, sans-serif; color: #01A9E0; text-decoration: none;'>Rakiya.lk</a>, and <a href='https://hrnews.lk/' target='_blank' rel='noreferrer' style='font-family: Poppins, sans-serif; color: #01A9E0; text-decoration: none;'>HRNews.lk</a>, ensuring all relevant roles are published across these platforms free of charge, giving you greater visibility while all CVs are seamlessly managed through the XpressJobs ATS. Additionally, XpressJobs has powered numerous university and school OBA job portals.<br><br>For employer branding campaigns or to publish HR articles via <a href='https://hrnews.lk/' target='_blank' rel='noreferrer' style='font-family: Poppins, sans-serif; color: #01A9E0; text-decoration: none;'>HRNews.lk</a>, feel free to get in touch with us.",
        brands: [
            {
                name: "InternJobs.lk",
                image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/intern-jobs-logo.png",
                url: "https://internjobs.lk/"
            },
            {
                name: "MyJobs.lk",
                image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/my-jobs-logo.png",
                url: "http://myjobs.lk/"
            },
            {
                name: "Rakiya.lk",
                image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/rakiya-lk-logo.png",
                url: "https://rakiya.lk/"
            },
            {
                name: "HRNews.lk",
                image: "https://v2-marketing-content.s3.ap-southeast-1.amazonaws.com/for-recruiters/hr-news-logo.png",
                url: "https://hrnews.lk/"
            }
        ]
    },
    packagetypes: {
        unlimited: "Unlimited",
        cvBased: "CV-Based"
    },
    specialPackage: {
        title: "Special Features",
        description: "Reach more candidates with our special features",
        expand: "See what’s included",
        featuresList: [
            {
                featureListId: 1,
                featureTopic: "SMS Feature",
                features: [
                    {
                        feature: "Instant candidate notifications"
                    },
                    {
                        feature: "Direct SMS reach"
                    },
                    {
                        feature: "Boosts engagement fast"
                    },
                    {
                        feature: "Real-time job alerts"
                    }
                ]
            },
            {
                featureListId: 2,
                featureTopic: "Promote Ad",
                features: [
                    {
                        feature: "Top placement for ads"
                    },
                    {
                        feature: "Stand out from competitors"
                    },
                    {
                        feature: "Priority listing exposure"
                    },
                    {
                        feature: "Higher applicant visibility"
                    }
                ]
            },
            {
                featureListId: 3,
                featureTopic: "Banner",
                features: [
                    {
                        feature: "Employee Branding"
                    },
                    {
                        feature: "Targeting segmentation of Jobs"
                    },
                    {
                        feature: "4 Million views a month"
                    },
                    {
                        feature: "High impact brand placement"
                    },
                    {
                        feature: "Catch candidates' eye"
                    }
                ]
            }
        ]
        
    },
    faqs: {
        subTitle: "FAQs",
        title: {
            black: "Here are some ",
            green: "answers ",
            greenToBlack: "for you"
        },
        description: "XpressJobs offers packages to suit both SMEs, startups, and enterprises. We provide two types of CV packages: one off CV based packages and unlimited packages, available on both monthly and contract basis. If you are unsure which package is right for you, call us on 011 7422414. <br> You can also refer to our FAQ for answers to common questions.",
        questions: [
            { 
                question: "What is filtering?",
                answer: "Filtering is a simple concept where we ask the candidates mandatory questions when they apply for a job. These questions can be Yes/No, Single Choice, Multiple Choice, Knockout, or open-ended. This was developed simply to reduce the workload of the HR personnel. We are not a head hunting company so we simply automate the ranking system for each individual based on the answers they give. For example, for a sales position, you can ask questions such as would you like to join the sales team, are you willing to do target based sales. You will be surprised the number of people who might apply but not match the criteria you will be looking for. The system will send you the CV along with the answers."
            },
            { 
                question: "What do you mean by 50CV, 100CV package , etc.?",
                answer: "We charge companies based on the number of CVs a company would like to receive and not on the number of job adverts you post.  For example: If you take our 50CV package you can post even 2-3 adverts and your adverts will stay live until you get 50CVs. These are fresh CVs and not CVs from a database. Candidates will read your job spec and apply only if they like to do the job."
            },
            { 
                question: "Is your CV packages only valid for a month?",
                answer: "No, our CV packages do not have an expiry date. You can use your quota any day until you receive the CV number you paid for, you can use one CV package between several number of positions.  Only our Unlimited CVs a month package is a monthly package, all our 50, 100, 250, 500 CV packages do not have an expiry date."
            },
            { 
                question: "Can you allocate CVs for a position?",
                answer: "Yes, if you get a 100CV package and post 4 adverts you can allocate 25CVs each per position. Adverts will automatically archive when it reaches the selected number of CVs."
            },
            { 
                question: "Do you give CVs from your database? Like, do you matchmake?",
                answer: "No, we don’t match candidates for you. We are not a head hunting company. All CVs you get are from fresh candidates. Candidates read the job spec then apply for the job only if they like to do the job. We don’t send it to you ; the candidates do."
            },
            { 
                question: "Do you send us filtered CVs only?",
                answer: "You can ask the system to send you only passed candidates or you can ask the system to send you all candidates. Depending on your preference."
            },
            { 
                question: "Are you charging me only for the filtered/ passed candidates?",
                answer: "No, We have defined our pricing model to be fair to both the recruiters and Xpressjobs. Currently “how tight the questions” is defined by the recruiter, number of questions, the pass mark and knockout questions are defined by the recruiter too."
                        + "If we bill only for successful candidates recruiters can tailor questions in a way that only 1 of every 100 applicants will be billed – but the remaining 99 would have used our resources (i.e., network bandwidth, etc.). We also want to keep the pricing model simple and easy to understand, so we have come up with the unlimited CVs a month option too."                        
            },
            { 
                question: "Can I post adverts by myself?",
                answer: "Yes, our system is designed for you to put up the adverts yourself. If you are struggling alternatively you can send it to us too."
            },
            { 
                question: "How do I get a sponsored facebook boost advert / How do I get target based social media advert?",
                answer: "All our packages over 100CVs will include a social media boost advert, For example, if you are looking for sales executives from Kalutara we can target 18-30, male only, in Kalutara, who have sales in their designation on social media."
            },
            { 
                question: "Do I have to pay you extra for the social media package?",
                answer: "No, Cost of boosting on social media and graphic is included in the package. If you take any package over 100CVs you get one target based social media boost."
            },
            { 
                question: "What is a video job advert, why should I do it?",
                answer: "If you been struggling to hire, lets give a face to your company. explaining the job in a 2-3 minute video does wonders. You can explain the job better on a video than put it to words for a job advert. It shows that there is someone who is brave enough to represent the company, and it's a real job. Video jobs are always good for branding."
            },
            { 
                question: "What is a CV-Less system?",
                answer: "CV-Less system is for candidates who might not have a CV but would still like to do the job. Instead of a CV you get them to fill a form, These candidates are tech-savvy enough to browse internet have a Facebook account but does not have CV. This is especially been working great with blue-collar, sales, customer service positions."
            },
            { 
                question: "Can we get access to your CV database?",
                answer: "No, we do not give you access to our CV database due to privacy issues. Plus looking at CVs from a database is never successful from our experience and you wouldn’t like us to share the CVs your company got with another? Now would you ? instead we do give you your own CV database. Anyone who applies to you stays in your system eventually getting you your own cv database."
            },
            { 
                question: "Do you share the CVs our company got with another?",
                answer: "No we don’t, CVs you get are not shared with another company ever. Applicants are the ones who can apply to the job. CV database is not given access too."
            },
            { 
                question: "What is your application tracking system?",
                answer: "We have inbuilt backend where you can manage your applicants, from interview process to hiring to offering the job."
            }                        
        ]
    },
    register: {
        text: "Try us out today and see the difference in the game."
    },
    bestHire: {
        subTitle: "We help you to",
        title: {
            black: "Hire the best in the ",
            blue: "industry"
        },
        description: "XpressJobs is the trendsetter in recruitment technology in Sri Lanka with filtering, CV-less, ATS, and online Quizzes, and many more rec tech to use.",
        videoURL: "https://www.youtube.com/embed/Eoe_VEf7KLU?si=mWcQHOEH9EF9ercu"
    },
}

export const  GoogleMapTexts = {
    markerURL: "https://www.google.com/maps/vt/icon/name=assets/icons/spotlight/spotlight_pin_v4_outline-2-medium.png,assets/icons/spotlight/spotlight_pin_v4-2-medium.png,assets/icons/spotlight/spotlight_pin_v4_dot-2-medium.png&highlight=c5221f,ea4335,b31412?scale=1",
    locationURL: "https://www.google.com/maps/place/XpressJobs/@6.915065,79.85273,20z/data=!4m14!1m7!3m6!1s0x3ae2596a037bddb3:0x913d83bb98e1f46e!2sSupreme+Corporate+Solutions+(Pvt)+Ltd!8m2!3d6.914933!4d79.8525303!16s%2Fg%2F11c7614506!3m5!1s0x3ae25bdf2f5c384d:0x58cf15579acc3966!8m2!3d6.9150188!4d79.8527285!16s%2Fg%2F11g8wvrpn4?hl=en-US&entry=ttu"
}

export const FAQTexts = [
    {
        categoryId: 0,
        categotyName: "CV Packages",
        faqs: [
            {
                id: 1,
                Question: "What do you mean by a 50 CV, 100 CV package, etc.?",
                Answer: [
                    "We charge companies based on the number of CVs they want to receive, not the number of job adverts they post.",
                    "For example, if you purchase a **100 CV package**, you can post multiple job adverts, and all those ads will remain live until you receive **100 CVs in total** across all your job postings.",
                    "All CVs are **fresh applications**, not taken from a database. Candidates apply only after reading your job description and choosing to submit their application because they are genuinely interested in the role."
                ]
            },
            {
                id: 2,
                Question: "Do the CV packages expire after one month?",
                Answer: [
                    "No, our CV packages do not expire. You can use your CV quota at any time until you receive the total number of CVs you purchased. Each package can also be used across multiple job positions.",
                    "Only the **Unlimited CVs per month** package works on a monthly subscription. All other packages (50, 100, 250, and 500 CVs) have no expiration.",
                    "However, for recruiters hiring for a single position, we recommend allocating at least 30 CVs per position."
                ]
            },
            {
                id: 3,
                Question: "Can I allocate CVs to specific positions?",
                Answer: "Yes. For example, if you purchase a **100 CV** package and post 4 job adverts, you can allocate 25 CVs per position. Each advert will automatically archive once it reaches its allocated CV limit, giving you full control over how your CV quota is distributed."
            },
            {
                id: 4,
                Question: "Are you charging only for the filtered or passed candidates?",
                Answer: [
                    "No. We charge based on the total number of CVs received, not just the candidates who pass your filters. Recruiters have full control over the filtering criteria, including the number of questions, the pass mark, and any knockout questions.",
                    "If we charged only for passed candidates, recruiters could set extremely strict filters, causing most applicants to fail while still using system resources such as network bandwidth and processing power.",
                    "To keep pricing fair, simple, and transparent, all CVs are counted, and we also offer an Unlimited CVs per month package for companies that prefer unrestricted hiring."
                ]
            },
            {
                id: 5,
                Question: "Do you have a special package for a single advert?",
                Answer: "No, our pricing is based solely on the number of CVs received. There is no separate charge for individual adverts, and you are permitted to post multiple adverts within the allocated CV quota."
            },
            {
                id: 6,
                Question: "If there are any issues with my advert, can I get oversight? Will I have support?",
                Answer: [
                    "Yes, you will have a dedicated account manager whom you can contact for any guidance or insights.",
                    "We are here to support you and will provide assistance to ensure you achieve the best possible outcome from your job adverts."
                ]
            },
            {
                id: 7,
                Question: "What guarantee do I have that I will receive the full number of applications for the purchased quota?",
                Answer: "We guarantee that your adverts will continue running until the full number of applications included in your purchased quota is received. There is no expiry date on the quota. Any unused balance can be carried forward and used for current or future job openings. Our team also provides full support to help you meet your recruitment requirements."
            },
            {
                id: 8,
                Question: "Do you offer unlimited job posting packages?",
                Answer: [
                    "Yes, we offer unlimited job posting packages for durations of six months or one year. We also provide annual group packages tailored for groups of companies.",
                    "For more information, please contact our sales team at sales@xpress.jobs."
                ]
            }
        ]
    },
    {
        categoryId: 1,
        categotyName: "ATS",
        faqs: [
            {
                id: 1,
                Question: "What is your Application Tracking System (ATS)?",
                Answer: [
                    "Our Application Tracking System (ATS) helps HR teams manage and track job applicants in one place. It allows you to easily see who has applied, who matches the role, who has been shortlisted, and who has passed each stage.",
                    "The ATS also helps with interview scheduling and keeps track of every candidate’s progress throughout the hiring process. By organizing all applicant information in a single system, it makes recruitment faster, clearer, and more efficient for HR teams."
                ]
            },
            {
                id: 2,
                Question: "Do you provide CVs from your database or match candidates for us?",
                Answer: "No, we do not provide CVs from a database, nor do we match candidates on your behalf. We are not a headhunting service. All CVs you receive are fresh, direct applications from candidates who have read your job description and applied because they are genuinely interested in the role."
            },
            {
                id: 3,
                Question: "What is filtering?",
                Answer: [
                    "Filtering is a feature that allows you to ask mandatory questions from candidates when they apply for a job. These can be Yes/No, Single Choice, Multiple Choice, Knockout, or Open-ended questions. The purpose is to reduce HR workload by automatically ranking candidates based on their responses.",
                    "Since we are not a headhunting company, filtering simply helps you identify the most suitable applicants more efficiently. For example, for a sales position, you can ask questions such as, ‘Would you like to join the sales team?’ or ‘Are you willing to work in a target-based role?’ Many applicants may not meet these requirements, and filtering makes it easy to spot this early.",
                    "The system then sends you each CV along with the candidate’s answers, making shortlisting faster and more accurate."
                ]
            },
            {
                id: 4,
                Question: "Do you send us filtered CVs only?",
                Answer: "You can choose whether you want to receive only candidates who pass your filtering questions or all applicants. However, please note that all CVs received, whether they pass or fail the filtering criteria, will be counted toward your quota. The system will send CVs based on your selected preference."
            },
            {
                id: 5,
                Question: "Can I post adverts by myself?",
                Answer: "Yes, our system is designed for you to publish your job adverts independently. If you encounter any difficulties, simply send us the details, and we will post them on your behalf."
            },
            {
                id: 6,
                Question: "What is a video job advert and why should I use it?",
                Answer: "A video job advert is a short 2–3 minute clip in which someone from your company explains the role. If you’ve been struggling to hire, putting a face to your company can make a significant difference. Videos allow you to communicate the job more clearly than text, demonstrate that the role is genuine, and showcase your company’s confidence in its brand. Additionally, video adverts strengthen your employer branding and attract more suitable candidates."
            },
            {
                id: 7,
                Question: "Do you share the CVs our company receives with other companies?",
                Answer: "No, we never share the CVs your company receives with any other organization. All applicants apply directly to your job, and our CV database remains private and inaccessible to others."
            },
            {
                id: 8,
                Question: "Can we get access to your CV database?",
                Answer: "No, we do not provide access to our CV database due to privacy concerns. In our experience, searching a CV database rarely leads to successful hires. Moreover, you wouldn’t want the CVs your company receives to be shared with other organizations. Instead, every applicant who applies to your jobs stays in your system, allowing you to build your own CV database over time."
            },
            {
                id: 9,
                Question: "How does the questionnaire help to filter candidates?",
                Answer: "The questionnaire helps filter candidates by allowing you to ask mandatory questions during the application process. Based on their answers, the system can automatically rank applicants and highlight those who meet your criteria. This makes it easier to identify suitable candidates quickly and reduces the time spent reviewing applications that don’t match the requirements."
            },
            {
                id: 10,
                Question: "Can interview invitations and updates be sent directly through the system?",
                Answer: "Yes, interview invitations and updates can be sent directly from the backend system. This allows you to communicate with candidates efficiently and keep them informed about interview schedules or any other updates."
            },
            {
                id: 11,
                Question: "Does the ATS show which CVs have been opened or shortlisted?",
                Answer: "Yes, the ATS allows you to track recruiter actions and shows which applications have been opened or shortlisted. This helps monitor how each application is being handled within the system."
            },
            {
                id: 12,
                Question: "How do we categorise the applications?",
                Answer: "Applications can be categorized by their status, such as New Applicant, Screening Passed, Screening Failed, Rejected, Shortlisted, Booked for Interview, Unreachable, Interview No-Show, and so on. This makes it easy to track and manage applicants at each stage of the recruitment process."
            },
            {
                id: 13,
                Question: "Can we get applications via email?",
                Answer: "Yes. All applications submitted by candidates are sent directly to the recruiter’s email, in addition to appearing in the ATS dashboard."
            },
            {
                id: 14,
                Question: "How can I check the applications? Can I receive them on WhatsApp?",
                Answer: "There are two main ways to access the applications: via email or through our ATS platform. We recommend using the ATS, as it provides a more streamlined experience and allows you to manage the entire shortlisting process efficiently. Unfortunately, it is not possible to receive applications through WhatsApp."
            },
            {
                id: 15,
                Question: "How long will it take to receive the full number of applications?",
                Answer: [
                    "The timeline depends on several factors. A strong brand presence and effective employee branding play a significant role in attracting candidates quickly.",
                    "Additionally, companies that clearly mention salary and benefits tend to receive applications faster. Other factors, such as the company’s reputation, the time of year, and market conditions, can also influence the response time."
                ]
            },
            {
                id: 16,
                Question: "Do you handle shortlisting and interviews on our behalf and send the applications?",
                Answer: "No. We advertise your job openings and support you in receiving applications. When candidates apply, our screening system automatically filters applications based on the job description you provide. You can then shortlist candidates through your recruiter account and conduct the interview process accordingly."
            },
            {
                id: 17,
                Question: "What can recruiters manage within the ATS dashboard?",
                Answer: "Within the ATS dashboard, recruiters can manage the entire recruitment process, including posting job adverts, reviewing applications, tracking candidate progress, shortlisting applicants, scheduling interviews, sending interview invitations and updates, and maintaining records of all candidate interactions. They can also monitor how many applications are coming in, giving a clear view of candidate flow and recruitment activity."
            }
        ]
    },
    {
        categoryId: 2,
        categotyName: "CV Less Application",
        faqs: [
            {
                id: 1,
                Question: "What is a CV-Less application system?",
                Answer: [
                    "A CV-Less application system allows candidates to apply for jobs without uploading a CV. Instead, they complete a simple online form with their personal details, experience, and qualifications.",
                    "This method is ideal for skilled labour roles, trainees, sales positions, and when targeting candidates outside Colombo who may have a mobile phone but not access to a computer. It enables candidates to quickly and easily apply on the go, making the hiring process more accessible and efficient."
                ]
            },
            {
                id: 2,
                Question: "How does the CV-Less application process work?",
                Answer: "In the CV-Less application system, candidates without a formal CV can easily apply by filling out and answering the required questions. Once completed, the application form is submitted. If a candidate already has a CV, they also have the option to upload it after submitting their application."
            },
            {
                id: 3,
                Question: "What is the difference between CV-Less and CV-based adverts?",
                Answer: [
                    "CV-Less adverts are designed for skilled labour roles such as electricians, technicians, helpers and similar positions where candidates may not have a formal CV. Applicants simply answer a customized set of questions, and the system captures their responses in an easy-to-review Excel format.",
                    "CV-based adverts are used for white-collar, professional, and skilled office-based positions, where candidates are required to upload their CVs as part of the application process."
                ]
            }
        ]
    },
    {
        categoryId: 3,
        categotyName: "Statistics",
        faqs: [
            {
                id: 1,
                Question: "What insights does the Statistics & Trends dashboard provide?",
                Answer: "The Statistics & Trends dashboard gives you clear visibility into your recruitment performance, including the number of applications received, candidate sources, and application status breakdowns over time. It helps you identify hiring patterns, measure recruitment effectiveness, and make data-driven decisions to improve your recruitment strategy."
            },
            {
                id: 2,
                Question: "Can sub-logins and group account users see these statistics?",
                Answer: "Yes. Sub-logins can view statistics based on the access permissions assigned to them. For group accounts, the Head of HR or main account holder can view consolidated statistics across all companies, locations, or job postings under the group account, providing a complete overview of recruitment performance at both individual and group levels."
            }
        ]
    },
    {
        categoryId: 4,
        categotyName: "Online Quizzes",
        faqs: [
            {
                id: 1,
                Question: "What is an online quiz?",
                Answer: "An online quiz is a digital assessment used during the recruitment process to evaluate candidates’ knowledge, skills, and suitability for a role. At XpressJobs, online quizzes are conducted as multiple-choice questions (MCQs), allowing for a standardized and objective assessment of applicants."
            },
            {
                id: 2,
                Question: "Are quizzes timed?",
                Answer: "Yes, quizzes can be timed. You can set a specific duration for each quiz, ensuring candidates complete it within the allotted time."
            },
            {
                id: 3,
                Question: "What is the main purpose of XpressJobs Online Quizzes?",
                Answer: [
                    "The main purpose of XpressJobs Online Quizzes is to help recruiters efficiently assess candidates and shortlist the most suitable applicants. While we currently support MCQ-based quizzes, we have successfully delivered large-scale quiz solutions for banks and enterprise clients, including Management Trainee (MT) and Internship programs.",
                    "These quiz campaigns can also include data capture cards and additional assessment components. For customized quiz requirements, we recommend discussing your needs with your sales account manager."
                ]
            }
        ]
    },
    {
        categoryId: 5,
        categotyName: "AI Assistant",
        faqs: [
            {
                id: 1,
                Question: "How does the AI identify and reach out to potential candidates?",
                Answer: "The AI analyzes data from the jobseeker database, such as skills, past applications, and job preferences, to identify candidates who match the requirements of a specific vacancy. Once suitable candidates are detected, the AI automatically reaches out to them through WhatsApp, starts a conversation, shares job details, answers questions, and encourages them to apply. This ensures the role is promoted directly to the right people, increasing both response rates and application quality."
            },
            {
                id: 2,
                Question: "Can candidates chat with the AI to ask questions about the role?",
                Answer: "Yes. Candidates can chat with the AI in real time to ask questions about the job, requirements, salary range, location, interview process, and more. The AI provides instant, accurate responses, creating a smooth and interactive experience."
            }
        ]
    },
    {
        categoryId: 6,
        categotyName: "Features",
        faqs: [
            {
                id: 1,
                Question: "How do I get a sponsored Facebook boost or target-based social media advert?",
                Answer:  [
                    "All our packages of 100 CVs or more include a social media boost. You can send us your brand guidelines, and we will create the post according to your specifications and share it across all our social media channels such as Facebook, LinkedIn, and Instagram.",
                    "If you want a paid/targeted boost (e.g., reaching specific locations, age groups, or job roles), this requires an additional budget to be provided by your company. Our team can guide you on the best targeting options to maximize reach and applications."
                ]
            },
            {
                id: 2,
                Question: "Do I have to pay extra for the social media package?",
                Answer: "No, the creation of graphics and a standard social media post is included in the package. However, if you want a targeted boost (e.g., reaching specific locations, age groups, or job roles), that requires an additional budget for paid promotion. Packages over 100 CVs include the standard post and guidance for boosting at no extra cost."
            },
            {
                id: 3,
                Question: "Is the \"Recruitment Technology Specialist\" Certificate issued based on training completion or system usage?",
                Answer: [
                    "The ‘Recruitment Technology Specialist’ Certificate is awarded based on practical proficiency in using the XpressJobs platform, including posting job adverts and setting up filtering questions.",
                    "It is a LinkedIn-recognized certification and comes with both a digital license and a hard copy of the certificate. The program is designed for the HR community to validate their skills in recruitment technology and applicant tracking."
                ]
            },
            {
                id: 4,
                Question: "How to feature a Job Advert?",
                Answer: "To feature a job advert, you can select the ‘Feature Job’ option when posting or managing your job listing in the system. Featured jobs receive higher visibility, making them stand out to candidates and attracting more applications."
            },
            {
                id: 5,
                Question: "What is unlimited job posting?",
                Answer: "Unlimited job posting allows you to publish as many job adverts as you need until the CV limit for your plan is reached. This lets your company advertise multiple roles simultaneously and continuously, helping you reach more candidates and streamline your hiring process."
            },
            {
                id: 6,
                Question: "How do email campaigns target candidates for the available positions?",
                Answer: "Email campaigns are sent to candidates with similar interests related to the job, helping to attract more suitable applicants and increase the chances of finding the right fit for the role."
            },
            {
                id: 7,
                Question: "How does the SMS Service help with walk-in interviews?",
                Answer: "When a candidate applies for a walk-in interview job, they instantly receive an SMS confirming the interview date, time, venue, and contact details, helping reduce confusion and no-shows."
            },
            {
                id: 8,
                Question: "How is the Targeted Base Email Campaign different from a regular email blast?",
                Answer: "In a Targeted Base Email Campaign, our team manually shortlists candidates from the XpressJobs database based on your job requirements. Emails are personalized with relevant details such as previous jobs they applied for, years of experience, location, and skill set, resulting in higher open rates and stronger engagement compared to a generic email blast."
            },
            {
                id: 9,
                Question: "Why should I choose a Targeted Base WhatsApp Campaign for hiring?",
                Answer: [
                    "A Targeted Base WhatsApp Campaign delivers personalized messages directly to shortlisted candidates, ensuring high visibility and faster reach. WhatsApp has a higher open rate than email and feels more personal, as it’s a platform candidates use to communicate with friends.",
                    "These campaigns can be one-way broadcasts or two-way conversations, allowing candidates to respond directly and engage with your recruitment team in real time."
                ]
            },
            {
                id: 10,
                Question: "What benefits does the Banner Campaign offer?",
                Answer: [
                    "The Banner Campaign gives your brand maximum visibility across the XpressJobs platform, reaching 5–5.5 million monthly sessions.",
                    "Every user whether they are posting a job or browsing listings will see your banner. It is displayed in 4 prominent locations on the platform, not just one, ensuring strong and consistent exposure. You can also target by industry, location, and job category for more relevant visibility."
                ]
            },
            {
                id: 11,
                Question: "Can I target banners by industry, job category, or location?",
                Answer: "Yes. Banner campaigns can be targeted by industry, job category, and location to ensure your ads reach the most relevant jobseeker audience."
            },
            {
                id: 12,
                Question: "Do you provide design support, or do we need to submit our own artwork?",
                Answer: "You can either submit your own banner artwork, or our team can design the banner for you at no additional cost. We ensure the design meets platform specifications and delivers maximum impact."
            },
            {
                id: 13,
                Question: "How can I purchase banner advertising space on the XpressJobs website?",
                Answer: "You can purchase banner advertising space by contacting our sales team through the XpressJobs platform either via the **Contact Us** form or directly through your account representative. They will guide you through available packages, pricing, targeting options, and next steps to get your banner live."
            },
            {
                id: 14,
                Question: "How does getting an article published on HRNews.lk work?",
                Answer: [
                    "To get an article published on HRNews.lk, you can submit your content through our official submission process. Articles are reviewed by our editorial team to ensure they align with our focus on human resources, workplace trends, and professional development.",
                    "Once approved, your article will be edited for clarity and formatting before being published on the website. We also provide guidance on topic relevance and writing style to help your article reach the right audience."
                ]
            },
            {
                id: 15,
                Question: "How can we get our job posted on subdomains such as Rakiya.lk, Internjobs.lk, MyJobs.lk, etc.?",
                Answer: [
                    "To post your job on our subdomains like Rakiya.lk, Internjobs.lk, and MyJobs.lk, you can submit your job listing through our main job submission portal.",
                    "Once submitted, our team reviews the listing to ensure it meets our quality and relevance guidelines. After approval, your job will be published on the selected subdomains, making it visible to a targeted audience looking for career opportunities in that sector. Some subdomains may have specific criteria or fees, which will be communicated during the submission process."
                ]
            }
        ]
    }
]

export const InternalGroupEmails = [
    {
        id: 1,
        name: "Sales Team",
        email: "sales@xpress.jobs"
    },
    {
        id: 2,
        name: "Support Team",
        email: "support@xpress.jobs"
    },
    {
        id: 3,
        name: "Technical Team",
        email: "tech@xpress.jobs"
    },
    {
        id: 4,
        name: "Other",
        email: "info@xpress.jobs"
    }
]

export const CandidateToEmailTemplate = `<div style="background:#00A9E0; padding:15px; color:#fff; font-weight:bold; font-family:Arial, sans-serif;">
    XpressJobs
</div>

<div style="padding:20px; font-size:14px; color:#333; font-family:Arial, sans-serif; line-height:1.5;">
    If you need help, you can find it here:
    <a href="https://xpress.jobs/contact" style="color:#00A9E0; text-decoration:none;">XpressJobs Support</a>
    <br><br>
    Regards,<br>
    <a href="mailto:team@xpress.jobs" style="color:#00A9E0; text-decoration:none;">XpressJobs | Team</a>
</div>

<!-- FOOTER -->
<div style="background:#00A9E0; color:#fff; font-size:12px; padding:15px; font-family:Arial, sans-serif;">
    
    <!-- Flex container (email-safe using tables) -->
    <table width="100%" cellpadding="0" cellspacing="0" style="color:#fff; font-family:Arial, sans-serif;">
        <tr>
            <!-- LEFT SIDE -->
            <td valign="top" style="text-align:left; line-height:1.5; font-size:12px; color:#fff;">
                XpressJobs.lk (Pvt) Ltd.<br>
                2-2/1, Temple Lane, Colombo 03
            </td>

            <!-- RIGHT SIDE -->
            <td valign="top" style="text-align:left; line-height:1.5; font-size:12px; color:#fff;">
                Phone: 011-7422414<br>
                Email: <a href="mailto:info@xpress.jobs" style="color:#fff; text-decoration:none;">info@xpress.jobs</a>
                &nbsp;&nbsp;
                <a href="https://www.facebook.com/xpressjobs/">
                    <img src="http://htmlsig.com/images/icon-komodo/facebook.png" alt="Facebook" style="width:16px; vertical-align:middle;">
                </a>
                &nbsp;
                <a href="https://twitter.com/xpressjobslk">
                    <img src="http://htmlsig.com/images/icon-komodo/twitter.png" alt="Twitter" style="width:16px; vertical-align:middle;">
                </a>
            </td>
        </tr>
    </table>

</div>
`
export const CheckoutCVPackagesTexts = {
    title: "PAYMENTS CAN BE MADE TO THE FOLLOWING ACCOUNT",
    accountDetails: [
        {
            id: 1,
            detail: "Bank name - Commercial Bank Reid Avenue Branch"
        },
        {
            id: 2,
            detail: "Account Name - XPRESSJOBS.LK PVT LTD"
        },
        {
            id: 3,
            detail: "Account Number - 1116017632"
        },
        {
            id: 4,
            detail: "Currency - LKR(Sri Lankan Rupee)"
        },
        {
            id: 5,
            detail: "SWIFT CODE - CCEYLKLX"
        },
    ],
    footer: "Please send a copy of the deposit slip to info@xpress.jobs or finance@xpress.jobs after the payment.",
    termsConditions: [
        "All payments are non-refundable",
        "It can take up to 1 hour (during office hours 9.00 am to 6.00pm) for your ad to be published.",
        "Adverts posted during weekends / Poya / Mercantile Holidays or adverts posted after 5.00pm will be published on next available working day"
    ]
}

export const ApplicationStatusPageTexts = {
    STAGE_STATUS_MAP: {
        "New": ["New Applicant"],
        "Screening": ["Screening Passed", "Screening Incomplete", "Screening Failed"],
        "Shortlisted": ["Shortlisted"],
        "Quiz": ["Quiz Passed", "Quiz Pending", "Quiz Failed", "Quiz Incomplete"],
        "Interview": ["Booked for Interview 1", "Booked for Interview 2", "Interview No Show"],
        "Decision": ["Rejected", "Job Offered"],
        "Unresponsive": ["Fake Answered", "Unreachable"]
    } as Record<string, string[]>
}